import { render, staticRenderFns } from "./Zahlungen.vue?vue&type=template&id=3c5da0c9&"
import script from "./Zahlungen.vue?vue&type=script&lang=js&"
export * from "./Zahlungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports